export default "__VITE_ASSET__C9bmTFTh__"